module.exports = __webpack_public_path__ + "img/Tinnerö.7402abc7.jpg";